module.exports = __webpack_public_path__ + "src/assets/games/2/beijingqiche1.png";